/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StockItemDto as DigiworkMaitreDPosDtoStockItemStockItemDto } from '../../models/Digiwork/MaitreD/Pos/DTO/StockItem/stock-item-dto';
import { UpdateStockItemDto as DigiworkMaitreDPosDtoStockItemUpdateStockItemDto } from '../../models/Digiwork/MaitreD/Pos/DTO/StockItem/update-stock-item-dto';

export interface UpdateStockItem$Params {
  stockItemId: string;
      body?: DigiworkMaitreDPosDtoStockItemUpdateStockItemDto
}

export function updateStockItem(http: HttpClient, rootUrl: string, params: UpdateStockItem$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoStockItemStockItemDto>> {
  const rb = new RequestBuilder(rootUrl, updateStockItem.PATH, 'put');
  if (params) {
    rb.path('stockItemId', params.stockItemId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoStockItemStockItemDto>;
    })
  );
}

updateStockItem.PATH = '/api/stock-items/{stockItemId}';
